import { Children, ReactNode } from "react";
import styled, { css } from "styled-components/macro";
import { THEME_COLOR, THEME_COLOR_DARK } from "../vars";

export default function BoxTimeline({ children }: { children: ReactNode }) {
  const arrayChildren = Children.toArray(children);
  return <PointsContainer>{arrayChildren}</PointsContainer>;
}

export function BoxTimelinePoint({
  children,
  isBlue,
}: {
  children: ReactNode;
  isBlue?: boolean;
}) {
  return (
    <Container>
      <>
        <PointCircle isBlue={isBlue} />
        <PointLine />
      </>
      <PointContent>{children}</PointContent>
    </Container>
  );
}

const PointsContainer = styled.div``;

const Container = styled.div`
  position: relative;
  text-align: left;
  transition-duration: 0.5s;
  &:not(:last-child) {
    padding-bottom: 20px;
  }
`;

const PointLine = styled.div`
  position: absolute;
  top: 24px;
  left: 9px;
  width: 80px;
  border-left: 1px solid transparent;
  border-top: 1px dashed #ccc;
  transition-duration: 0.5s;
  height: 100%;
  ${Container}:not(:last-child) & {
    border-left: 1px solid #d7d7d9;
  }
`;

const PointContent = styled.div`
  z-index: 1;
  transition-duration: 0.2s;
  padding-left: 40px;
`;

const PointCircle = styled.div<{ isBlue?: boolean }>`
  position: absolute;
  left: 10px;
  top: 16px;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1000px;
  width: 16px;
  height: 16px;
  z-index: 1;
  background: white;
  border: 1px solid #d7d7d9;
  ${(p) =>
    p.isBlue &&
    css`
      background: ${THEME_COLOR};
      border-color: ${THEME_COLOR_DARK};
    `}
`;
